var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import ButtonBasic from "@rentiohq/shared-frontend/dist/components/components/ButtonBasic";
import Spacer, { ESpacerWeight, } from "@rentiohq/shared-frontend/dist/components/components/Spacer";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import ReactMarkdown from "react-markdown";
import { useSelector } from "react-redux";
import { Banner } from "../../Banner";
import { Icon } from "../../Icon";
import { useArrayItemData } from "../contexts/ArrayItemContext";
export var InfoField = function (props) {
    var uiSchema = props.uiSchema, formContext = props.formContext, formData = props.formData;
    var _a = uiSchema, icon = _a.icon, subtitle = _a.subtitle, getSubtitle = _a.getSubtitle, subtitleIsMarkdown = _a.subtitleIsMarkdown, actionTitle = _a.actionTitle, type = _a.type, onPressAction = _a.onPressAction, infoUrl = _a.infoUrl, infoIcon = _a.infoIcon, infoLabel = _a.infoLabel;
    // @ts-ignore TODO: Typescript upgrade
    var title = getFieldTitle(uiSchema, formContext);
    var arrayItemData = useArrayItemData();
    var customSubtitle = useSelector(function (state) {
        return subtitle ||
            (!!getSubtitle &&
                getSubtitle(state, formContext.getAllFormData(), formData, arrayItemData));
    });
    // Only allow http(s) links - guards against a `javascript:`/`data:` href XSS.
    var safeInfoUrl;
    if (infoUrl) {
        try {
            var protocol = new URL(infoUrl).protocol;
            safeInfoUrl =
                protocol === "http:" || protocol === "https:" ? infoUrl : undefined;
        }
        catch (_b) {
            safeInfoUrl = undefined;
        }
    }
    return (_jsxs(Banner, { title: title, icon: icon, hasDismiss: false, variation: type, children: [(!!customSubtitle || safeInfoUrl) && (_jsxs("span", { style: subtitleIsMarkdown ? {} : { whiteSpace: "pre-line" }, children: [subtitleIsMarkdown ? (_jsx(ReactMarkdown, { components: {
                            a: function (_a) {
                                var node = _a.node, children = _a.children, props = __rest(_a, ["node", "children"]);
                                return (_jsx("a", __assign({}, props, { target: "_blank", rel: "noopener noreferrer", children: children })));
                            },
                        }, children: customSubtitle })) : (customSubtitle), safeInfoUrl && (_jsx("a", { href: safeInfoUrl, target: "_blank", rel: "noopener noreferrer", "aria-label": infoLabel, title: infoLabel, style: {
                            marginLeft: 6,
                            display: "inline-flex",
                            verticalAlign: "text-bottom",
                        }, children: _jsx(Icon, { source: infoIcon || "informationCircle", size: "small" }) }))] })), actionTitle && (_jsxs(_Fragment, { children: [_jsx(Spacer, { weight: ESpacerWeight.W04 }), _jsx(ButtonBasic, { title: actionTitle, onPress: onPressAction })] }))] }));
};
